var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-width-1-1",class:{ 'uk-form-icon': !!_vm.glyph , 'uk-height-1-1': !!_vm.height }},[(!!_vm.glyph)?_c('i',{class:`uk-icon-${_vm.glyph}`}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }